import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { BUSINESS } from "@/lib/site";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";

const GoogleMark = () => (
  <svg width="20" height="20" viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.5l6.8-6.8C35.8 2.4 30.2 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.9 6.1C12.4 13.5 17.7 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v8.5h12.7c-.6 3-2.2 5.5-4.7 7.2l7.6 5.9c4.4-4.1 6.9-10.1 6.9-17.1z" />
    <path fill="#FBBC05" d="M10.5 28.7A14.5 14.5 0 0 1 9.5 24c0-1.6.3-3.2.8-4.7l-7.9-6.1A24 24 0 0 0 0 24c0 3.9.9 7.5 2.6 10.8l7.9-6.1z" />
    <path fill="#34A853" d="M24 48c6.5 0 11.9-2.1 15.9-5.8l-7.6-5.9c-2.1 1.4-4.9 2.3-8.3 2.3-6.3 0-11.6-4.1-13.5-9.9l-7.9 6.1C6.5 42.6 14.6 48 24 48z" />
  </svg>
);

const hasGoogleUrl = BUSINESS.googleUrl.startsWith("http");

export const Reviews = () => (
  <section data-testid="reviews-section" aria-labelledby="reviews-heading" className="section section-alt">
    <div className="container-site">
      <SectionHeading id="reviews" title="What Our Customers Say" accent="Customers" />

      <Reveal className="mt-12">
        <div data-testid="reviews-placeholder" className="card flex min-h-[220px] items-center justify-center border-dashed p-8 text-center">
          <p className="text-base font-semibold uppercase tracking-[0.08em] text-navy">[AWAITING REAL GOOGLE REVIEWS]</p>
        </div>
      </Reveal>

      <Reveal className="mt-12 flex flex-col gap-4 sm:flex-row sm:items-center">
        <Link to="/reviews" data-testid="reviews-more-button" className="btn btn-outline w-full sm:w-auto">
          Read More Reviews
        </Link>
        <a
          href={hasGoogleUrl ? BUSINESS.googleUrl : "#reviews"}
          target={hasGoogleUrl ? "_blank" : undefined}
          rel={hasGoogleUrl ? "noopener noreferrer" : undefined}
          data-testid="reviews-google-link"
          className="inline-flex items-center justify-center gap-2 text-[15px] font-semibold text-brand transition-colors hover:text-brand-dark"
        >
          <GoogleMark />
          {hasGoogleUrl ? "See all DMS Home Improvements reviews on Google" : "[GOOGLE BUSINESS PROFILE URL]"}
          <ExternalLink size={16} aria-hidden="true" />
        </a>
      </Reveal>
    </div>
  </section>
);
